export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/mayodeclaro2026.jpg',
	   "funcion": 'Llegó el momento de declarar.',
		"url" : 'https://www.facebook.com/reel/948864241251554',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/recuperacontra2026.jpg',
	   "funcion": 'Declaración de Modificación',
		"url" : 'https://fb.watch/H17LIAGRzK/',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/dulce.jpg',
	   "funcion": 'Declaración de Modificación',
				"url" : 'https://www.facebook.com/share/p/1CpN9WepQv/',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]